import FilterTypeSignatures from '@/features/signatures/components/filter-type-signatures'
import ListSignatures from '@/features/signatures/components/list-signatures'
import SearchSignatures from '@/features/signatures/components/search-signatures'
import { PageLayout } from '@/layouts'

export default function SignaturesPage() {
  return (
    <PageLayout
      title="Assinaturas"
      description={
        <div className="flex flex-col md:flex-row justify-between gap-4 mb-4">
          <div className="flex flex-1 flex-col gap-4 md:flex-row">
            <SearchSignatures />
            <FilterTypeSignatures />
          </div>
        </div>
      }
    >
      <ListSignatures />
    </PageLayout>
  )
}
